import { render, staticRenderFns } from "./SkuFixedPeriod.vue?vue&type=template&id=60577f5e&scoped=true&"
import script from "./SkuFixedPeriod.vue?vue&type=script&lang=js&"
export * from "./SkuFixedPeriod.vue?vue&type=script&lang=js&"
import style0 from "./style.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./SkuFixedPeriod.vue?vue&type=style&index=1&id=60577f5e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60577f5e",
  null
  
)

export default component.exports